"use client";

import Link from "next/link";
import { getReferralBaseUrl } from "@/lib/referrals/constants";

/**
 * Apple Guideline 3.1.2(c): auto-renewable subscriptions must include functional links to
 * Privacy Policy and Terms of Use (EULA) in the subscription UI.
 *
 * Terms of Use (EULA): Apple’s standard Licensed Application EULA (required when using default EULA in App Store Connect).
 */
const APPLE_STANDARD_EULA_URL =
  "https://www.apple.com/legal/internet-services/itunes/dev/stdeula/";

export function IosSubscriptionLegalLinks() {
  const base = getReferralBaseUrl();
  const privacyUrl = `${base}/privacy`;

  return (
    <p className="w-full max-w-none text-xs text-neutral-500 text-left leading-relaxed">
      Payment will be charged to your Apple ID. Subscriptions renew automatically unless cancelled at least 24 hours before the end of the current period. Manage or cancel in your Apple ID account settings.{" "}
      <Link
        href={privacyUrl}
        className="text-primary font-medium underline underline-offset-2 hover:text-primary/90"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </Link>
      {" · "}
      <Link
        href={APPLE_STANDARD_EULA_URL}
        className="text-primary font-medium underline underline-offset-2 hover:text-primary/90"
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms of Use (EULA)
      </Link>
    </p>
  );
}
